import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import Images from "@/assets/images";
import { Image } from "expo-image";

const OnboardSlide14 = () => {
  return (
    <View style={styles.container}>
      <Image
        source={Images.flyMoney}
        style={styles.money}
        contentFit="contain"
      />
      <Text style={styles.title}>
        Based on your answers{"\n"}you missed out on...
      </Text>
      <Text style={styles.number}>$968</Text>
      <Text style={styles.note}>
        *This is an approximation based on the average payouts from past class
        actions, unclaimed money, and junk subscriptions
      </Text>
    </View>
  );
};

export default OnboardSlide14;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    gap: 16,
  },
  money: {
    width: 80,
    height: 80,
    marginTop: 16,
  },
  title: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#EBFFEE",
    textAlign: "center",
  },
  number: {
    fontFamily: FontFamilies.InterTight.Bold,
    fontSize: 80,
    color: "#EBFFEE",
    textAlign: "center",
    marginTop: 8,
  },
  note: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 16,
    color: "#EBFFEE",
    textAlign: "center",
    opacity: 0.7,
    paddingHorizontal: 8,
    marginBottom: 16,
  },
});
